<dcc-entity-search
  [entityTypes]="[entitySearchTypeFilter]"
  (clearEntity)="clearCompany()"
  (entity)="onCompanySelect($event)"></dcc-entity-search>
